let ReactPixel: any;

if (typeof window !== 'undefined') {
  ReactPixel = require('react-facebook-pixel').default;
}

const FacebookPixel = {
  init: () => {
    if (!ReactPixel) return;
    ReactPixel.init('704271787779728', undefined, {
      autoConfig: true,
      debug: false,
    });
  },
  pageView: () => {
    if (!ReactPixel) return;
    ReactPixel.pageView();
  },
  track: (event: string, data?: Record<string, any>) => {
    if (!ReactPixel) return;
    ReactPixel.track(event, data);
  },
  trackAddToCart: (data: {
    content_ids: string[];
    content_name: string;
    content_type: string;
    value: number;
    currency: string;
  }) => {
    if (!ReactPixel) return;
    ReactPixel.track('AddToCart', data);
  },
  trackStartTrial: (data: {
    content_name: string;
    content_category: string;
    value: number;
    currency: string;
  }) => {
    if (!ReactPixel) return;
    ReactPixel.track('StartTrial', data);
  },
  trackLead: (data?: Record<string, any>) => {
    if (!ReactPixel) return;
    ReactPixel.track('Lead', data);
  },
  trackCompleteRegistration: (data?: Record<string, any>) => {
    if (!ReactPixel) return;
    ReactPixel.track('CompleteRegistration', data);
  },
};

export default FacebookPixel;
